import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Layout } from '../../components/Layout/Layout';
import { NotFoundContent } from './components/NotFoundContent';
import { NotFoundFooter } from './components/NotFoundFooter';
import { NotFound as messages } from './messages';

export const NotFoundPage: VFC = () => (
  <Layout footerContent={<NotFoundFooter />} headerContent={<FormattedMessage {...messages.headerContent} />}>
    <NotFoundContent />
  </Layout>
);
